import React from 'react';
import { Icon } from 'neatui';
import './style.module.scss';

function UploadButton() {
  return (
    <div styleName="add">
      <Icon type="add" />
    </div>
  );
}

export default UploadButton;
